export default __webpack_public_path__ + "static/media/editNote.36e44eb4.svg";